<template>
  <v-container>
    <v-row align="center" justify="center" width="100%">
      <v-card light :flat="print" style="width: 28cm;">
        <v-card-text>
          <v-row>
            <v-col xs="12" class="mt-1 pa-0">
              <v-row>
                <v-col xs="6" class="text-left pr-0 pl-4">
                  <img responsive width="80%" :src="logoPath"/>
                  <br/>
                  <br/>
                  <div class="text-left" style="width: 80%;">
                    <span v-html="contactInfo ? $root.newLineToBR(contactInfo) : null"></span>
                  </div>
                </v-col>
                <v-col xs="6" class="pt-5">
                  <div style="border-left: 4px #999 solid" class="pl-2">
                    <v-simple-table dense class="mb-5">
                      <template v-slot:default>
                        <tbody>
                        <tr>
                          <th class="text-left" colspan="2">
                            <h1>Totals</h1>
                          </th>
                        </tr>
                        <tr>
                          <td class="text-left">Loads Count</td>
                          <td class="text-left">{{totalsCounts.loadsCount.toLocaleString()}}</td>
                        </tr>
                        <tr>
                          <td class="text-left">Total Miles</td>
                          <td class="text-left">{{totalsCounts.totalLoadsDistance.toLocaleString()}}{{$t('milesShort')}}</td>
                        </tr>
                        <tr>
                          <td class="text-left">Total Loads Rate</td>
                          <td class="text-left">{{ $root.moneyValue(totalsCounts.totalLoadsRate) }}</td>
                        </tr>
                        <tr>
                          <td class="text-left">Total Additional Payments</td>
                          <td class="text-left">{{ $root.moneyValue(totalsCounts.totalAdditionalPayments) }}</td>
                        </tr>
                        <tr>
                          <td class="text-left">Total Avg. Rate Per Mile</td>
                          <td class="text-left">{{ $root.moneyValue(totalsCounts.totalAvgLoadsRatePerMile) }}</td>
                        </tr>
                        <tr>
                          <td class="text-left">Total Gross Income</td>
                          <td class="text-left">{{ $root.moneyValue(totalsCounts.totalLoadsGross) }}</td>
                        </tr>
                        <tr>
                          <td class="text-left">Total Expenses</td>
                          <td class="text-left">{{ $root.moneyValue(totalsCounts.totalLoadsExpenses) }}</td>
                        </tr>
                        <tr>
                          <td class="text-left">Total Net Income</td>
                          <td class="text-left">{{ $root.moneyValue(totalsCounts.totalLoadsNet) }}</td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-col>
              </v-row>
              <h3 style="line-height: 32px;" class="text-center" v-html="title"></h3>
              <v-simple-table dense
                              style="border: 1px solid #000; background: transparent;"
                              class="text-left">
                <thead style="display: table-header-group;">
                  <tr style="background:#0090D3;color:#fff;page-break-inside: avoid;">
                    <th class="report_font_size_normal text-center white--text">#</th>
                    <th class="report_font_size_normal text-center white--text">Started<br/>Ended</th>
                    <th class="report_font_size_normal text-center white--text">Locations</th>
                    <th class="report_font_size_normal text-center white--text">Dispatcher<br/>Broker</th>
                    <th class="report_font_size_normal text-center white--text">Trucks<br/>Drivers</th>
                    <th class="report_font_size_normal text-center white--text">Load Number<br/>Load UID</th>
                    <th class="report_font_size_normal text-center white--text">Miles</th>
                    <th class="report_font_size_normal text-center white--text">Rate</th>
                    <th class="report_font_size_normal text-center white--text">Factoring</th>
                    <th class="report_font_size_normal text-center white--text">Gross</th>
                    <th class="report_font_size_normal text-center white--text">Expenses</th>
                    <th class="report_font_size_normal text-center white--text">Net Income</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in entries" style="page-break-inside: avoid;" :key="'item'+item.id">
                    <td>#{{item.id}}</td>
                    <td class="report_font_size_normal">
                      <div class="text-no-wrap">{{item.startedPST}}</div>
                      <div class="text-no-wrap">{{item.endedPST}}</div>
                    </td>
                    <td class="report_font_size_normal">
                      <div class="text-no-wrap" style="max-width: 150px; text-overflow: ellipsis; overflow: hidden;">
                        {{item.name.split('--')[0]}}
                      </div>
                      <div class="text-no-wrap" style="max-width: 150px; text-overflow: ellipsis; overflow: hidden;">
                        {{item.name.split('--')[1]}}
                      </div>
                    </td>
                    <td class="report_font_size_normal">
                      <span>{{item.dispatcherName}}</span>
                      <br/>
                      <span>{{item.brokerName}}</span>
                    </td>
                    <td class="report_font_size_normal">
                      <template v-for="(truck) in item.trucks">
                        <div class="text-no-wrap" :key="'truck' + truck.id">
                          {{truck.truckName}}&nbsp;
                          <template v-for="(driver) in truck.drivers">
                            {{driver.driverInitials}}&nbsp;
                          </template>
                        </div>
                      </template>
                    </td>
                    <td class="report_font_size_normal">
                      {{item.loadNumber}}
                      <br/>
                      {{item.uid}}
                    </td>
                    <td class="report_font_size_normal text-center">{{item.miles.toLocaleString()}} {{$t('milesShort')}}</td>
                    <td class="report_font_size_normal text-center">
                      <template v-if="item.additionalPayments !== 0">
                        {{parseFloat(item.Rate.toFixed(2)).toLocaleString()}}
                        {{item.RTLRate ? '+'+parseFloat(item.RTLRate.toFixed(2)).toLocaleString() : ''}}
                        {{item.additionalPayments > 0?'+':'-'}}{{parseFloat(item.additionalPayments.toFixed(2)).toLocaleString()}}=
                        <br/>
                        ${{getTotalRate(item)}}
                      </template>
                      <template v-else>
                        ${{parseFloat((item.Rate+(item.RTLRate||0)).toFixed(2)).toLocaleString()}}
                      </template>
                    </td>
                    <td class="report_font_size_normal text-center">{{item.factoring}}%</td>
                    <td class="report_font_size_normal text-center">${{parseFloat(item.gross).toLocaleString()}}</td>
                    <td class="report_font_size_normal text-center">${{parseFloat(item.expenses).toLocaleString()}}</td>
                    <td class="report_font_size_normal text-center">${{parseFloat(item.net).toLocaleString()}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>

import reportsMixin from '../../mixins/reportsMixin.js';

export default {
  name: 'LoadsReportTemplate',
  props: ['entries', 'totalsCounts', 'print', 'from', 'to', 'companyId'],
  mixins: [reportsMixin],
  components: {},
  data: function () {
    return {
      byStatusCounts: {},
      publicPath: process.env.BASE_URL,
      contactInfo: '',
      logoPath: '',
      title: ''
    };
  },
  computed: {
  },
  mounted () {
    this.$nextTick(() => {
      this.$root.getInvoiceLogoPath(this.companyId).then(path => {
        this.logoPath = path;
      });
      this.$root.getGlobalSettingsField('invoiceContactInfo', this.companyId).then((response) => {
        if (response.status === 'ok') {
          this.contactInfo = response.result;
        }
      });
      for (let i = 0; i < this.entries.length; i++) {
        const status = this.entries[i].status;
        if (!this.byStatusCounts.hasOwnProperty(status)) {
          this.byStatusCounts[status] = 0;
        }
        this.byStatusCounts[status] += 1;
      }
      this.generateReportTitle();
      document.title = this.title;
      this.$forceUpdate();
    });
  },
  methods: {
    generateReportTitle () {
      this.title = 'Loads ' + this.$root.t('Report') + ' ' + (parseInt(this.$route.params.report_number) > 0 ? '#' + this.$route.params.report_number : '') + ': ';
      this.$root.currentReportFileName = 'Loads_' + this.$root.t('Report') + (parseInt(this.$route.params.report_number) > 0 ? '_' + this.$route.params.report_number : '') + '_';
      if (this.entries && this.entries.length > 1) {
        this.title += this.entries[0].startedPST.substring(0, 10) + ' - ' + this.entries[this.entries.length - 1].startedPST.substring(0, 10);
        this.$root.currentReportFileName += this.$root.parseDate(this.entries[0].startedPST.substring(0, 10)) + '-' + this.$root.parseDate(this.entries[this.entries.length - 1].endedPST.substring(0, 10));
      }
      if (this.entries && this.entries.length === 1) {
        this.title += this.entries[0].startedPST.substring(0, 10);
        this.$root.currentReportFileName += this.$root.parseDate(this.entries[0].startedPST.substring(0, 10));
      }
    }
  }
};

</script>
